import React, { useEffect, useState } from "react";
import Navbar from "../navbar";
import Footer from "../footer";
import { Link } from "gatsby";

import "./style.scss";

import loadingIcon from "../../images/Rolling-1s-200px.gif";

import data from "./data";

import { useQueryParam, StringParam } from "use-query-params";
import SEO from "../seo";
export default function SearchPage() {
  const [search, setSearch] = useQueryParam("q", StringParam);
  const [dataToDisplay, setDataToDisplay] = useState([]);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
    if (search !== undefined) {
      if (search === "") {
        setDataToDisplay([]);
        return;
      }
      const newData = data.filter((item) =>
        item.searchslug.toLowerCase().includes(search.toLowerCase())
      );
      setDataToDisplay(newData);
    }
  }, [search]);

  //   useEffect

  let messageToDisplay = "";

  if (dataToDisplay.length === 0) {
    if (search !== undefined) {
      if (search.length > 0) {
        messageToDisplay = `Your search for "${search}" did not yield any results.`;
      }
    }
  }

  return (
    <div className="searchpage">
      <Navbar path="/search" />
      <SEO
        title="Eclipse International India | Search Luxury Bedding"
        description="Browse through series of handcrafted luxury mattresses by Eclipse. View by category, features and mattress benefits to find the mattress of your dreams."
      />
      <div className="searchpage__content">
        <h1 className="heading-primary">Search</h1>

        <p className="searchpage__des">
          Browse through series of handcrafted luxury mattresses by Eclipse.
          View by category, features and mattress benefits to find the mattress
          of your dreams.
        </p>
        <input
          placeholder="Search by products, features, or categories"
          className="searchpage__input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        ></input>
        <br />

        <hr />

        {!loading ? (
          <div>
            {dataToDisplay.length > 0 && (
              <div className="searchpage__result">
                Search Results: {dataToDisplay.length}
              </div>
            )}
            {dataToDisplay.map((item, i) => (
              <Link className="searchpage__link" to={item.link}>
                {item.title}{" "}
                <span className="searchpage__link__url">{item.link}</span>
                <br />
                <div className="searchpage__link__des">{item.description}</div>
              </Link>
            ))}

            {dataToDisplay.length === 0 && (
              <>
                <br />
                <br />
                {messageToDisplay}
              </>
            )}
          </div>
        ) : (
          <>
            <br />
            <br />
            <img alt="loading" src={loadingIcon} width="60" height="60"></img>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
